import gatewayConfig from './gatewayConfig';
export const offline = {
    leftIcon: [
        {
            id: 1,
            title: $t('integration.offline_analysis'),
            icon: 'el-icon-s-marketing',
            textVal: $t('integration.offline_analysis')
        }
    ],
    rightIcon: [
        {
            id: 1,
            title: $t('public.reflash'),
            icon: 'el-icon-refresh',
            click() {
                let config = this.localConfig;
                if (typeof config === 'string') config = JSON.parse(config);
                const save = this.saveList.map(item => item.deviceId).join(',');
                this.$parent.getEchart({ offerline: config.offerline }, save);
            }
        },
        {
            id: 2,
            title: $t('public.setting'),
            icon: 'el-icon-setting',
            click() {
                this.isShow = true;
                this.title = $t('integration.offline_analysis');
                const config = JSON.parse(JSON.stringify(gatewayConfig.offerline));
                delete config.check;
                this.diaConfig = { offerline: config };
                let cfg = this.localConfig;
                if (typeof cfg === 'string') cfg = JSON.parse(cfg);

                this.$nextTick(() => {
                    this.$refs['analSet'].setConfig(cfg);
                });
            }
        },
        {
            id: 3,
            title: $t('public.btn_close'),
            icon: 'el-icon-circle-close',
            click() {
                this.$delete(this.echartArray, 'offline');
            }
        }
    ]
};

export const configure = {
    leftIcon: [
        {
            id: 1,
            title: $t('integration.configuration_analysis'),
            icon: 'el-icon-crop',
            textVal: $t('integration.configuration_analysis')
        }
    ],
    rightIcon: [
        {
            id: 1,
            title: $t('public.reflash'),
            icon: 'el-icon-refresh',
            click() {
                let config = this.localConfig;
                if (typeof config === 'string') config = JSON.parse(config);
                const save = this.saveList.map(item => item.deviceId).join(',');
                this.$parent.getEchart({ configure: config.configure }, save);
            }
        },
        {
            id: 2,
            title: $t('public.setting'),
            icon: 'el-icon-setting',
            click() {
                this.isShow = true;
                this.title = $t('integration.configuration_analysis');
                const config = JSON.parse(JSON.stringify(gatewayConfig.configure));
                delete config.check;
                this.diaConfig = { configure: config };
                let cfg = this.localConfig;
                if (typeof cfg === 'string') cfg = JSON.parse(cfg);

                this.$nextTick(() => {
                    this.$refs['analSet'].setConfig(cfg);
                });
            }
        },
        {
            id: 3,
            title: $t('public.btn_close'),
            icon: 'el-icon-circle-close',
            click() {
                this.$delete(this.echartArray, 'configure');
            }
        }
    ]
};

export const powerout = {
    leftIcon: [
        {
            id: 1,
            title: $t('integration.outage_analysis'),
            icon: 'el-icon-connection',
            textVal: $t('integration.outage_analysis')
        }
    ],
    rightIcon: [
        {
            id: 1,
            title: $t('public.reflash'),
            icon: 'el-icon-refresh',
            click() {
                let config = this.config;
                if (typeof config === 'string') config = JSON.parse(config);
                const save = this.saveList.map(item => item.deviceId).join(',');
                this.$parent.getEchart({ powerout: config.powerout }, save);
            }
        },
        {
            id: 2,
            title: $t('public.setting'),
            icon: 'el-icon-setting',
            click() {
                this.isShow = true;
                this.title = $t('integration.outage_analysis');
                const config = JSON.parse(JSON.stringify(gatewayConfig.powerout));
                delete config.check;
                this.diaConfig = { powerout: config };
                let cfg = this.config;
                if (typeof cfg === 'string') cfg = JSON.parse(cfg);

                this.$nextTick(() => {
                    this.$refs['analSet'].setConfig(cfg);
                });
            }
        },
        {
            id: 3,
            title: $t('public.btn_close'),
            icon: 'el-icon-circle-close',
            click() {
                this.$delete(this.echartArray, 'powerout');
            }
        }
    ]
};

export const sensorStatus = {
    rightIcon: [
        {
            id: 1,
            title: $t('public.reflash'),
            middleText: '',
            icon: 'el-icon-refresh',
            click() {
                const save = this.saveList.map(item => item.deviceId).join(',');
                this.$parent.getPieChart(save, { sensorStatus: true });
            }
        }
    ]
};
export const sensorType = {
    rightIcon: [
        {
            id: 1,
            title: $t('public.reflash'),
            icon: 'el-icon-refresh',
            click() {
                const save = this.saveList.map(item => item.deviceId).join(',');
                this.$parent.getPieChart(save, { sensorType: true });
            }
        }
    ]
};
